module.exports = __webpack_public_path__ + "static/media/icon-fatoraty.b77e6156.svg";